/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { getNumberOfFilesInProgress } from '../../components/DelayedDownloadings/DelayedDownloadingsConfig';
import { DownloadingsAction, DownloadingsActionType } from '../actions/downloadingsActions';
import { DelayedDownloadingsListItemDto } from '../api/downloadings/downloadingsClient.typings';

export interface DownloadingsState {
    isLoading: boolean;
    delayedDownloadingsList: DelayedDownloadingsListItemDto[];
    isPollingEnabled: boolean;
}

const initialState: DownloadingsState = {
    isLoading: false,
    delayedDownloadingsList: [],
    isPollingEnabled: false,
};

function downloadingsReducer(state: DownloadingsState = initialState, action: DownloadingsAction): DownloadingsState {
    switch (action.type) {
        case DownloadingsActionType.GET_DELAYED_DOWNLOADINGS_START_ACTION:
        case DownloadingsActionType.DOWNLOAD_FILE_FROM_THE_LIST_START_ACTION:
        case DownloadingsActionType.DELETE_DELAYED_DOWNLOADINGS_ITEMS_START_ACTION:
        case DownloadingsActionType.DELETE_DELAYED_DOWNLOADINGS_ITEMS_SUCCESS_ACTION: //update the list on delete
            return {
                ...state,
                isLoading: true,
            };

        case DownloadingsActionType.GET_DELAYED_DOWNLOADINGS_SUCCESS_ACTION: {
            const numberOfFilesInProgress = getNumberOfFilesInProgress(action.payload);
            return {
                ...state,
                isLoading: false,
                delayedDownloadingsList: action.payload,
                isPollingEnabled: numberOfFilesInProgress > 0,
            };
        }

        case DownloadingsActionType.POLLING_DELAYED_DOWNLOADINGS_SUCCESS_ACTION: {
            const numberOfFilesInProgress = getNumberOfFilesInProgress(action.payload);
            return {
                ...state,
                delayedDownloadingsList: action.payload,
                isPollingEnabled: numberOfFilesInProgress > 0,
            };
        }

        case DownloadingsActionType.GET_DELAYED_DOWNLOADINGS_ERROR_ACTION:
        case DownloadingsActionType.DOWNLOAD_FILE_FROM_THE_LIST_ERROR_ACTION:
        case DownloadingsActionType.DOWNLOAD_FILE_FROM_THE_LIST_SUCCESS_ACTION:
        case DownloadingsActionType.DELETE_DELAYED_DOWNLOADINGS_ITEMS_ERROR_ACTION:
            return {
                ...state,
                isLoading: false,
            };

        default:
            return state;
    }
}

export default downloadingsReducer;
